<template>
  <div class="store">
    <div class="head">門店展示</div>
    <main>
      <img src="../assets/img/store.png" alt srcset />
      <div class="option">
        <div>
          <p class="en">
            RETAON門店信息
            <br />
            <span class="en">Store information</span>
          </p>
          <label for></label>
          <p class="desc">
            <span class="titel">聯係方式</span>
            <span>
              <img src="../assets/img/address.png" alt srcset />
              地址：{{store.address}}
            </span>
            <span>
              <img src="../assets/img/phone.png" alt srcset />
              Tel：{{store.custom_tel}}
            </span>
            <span>
              <img src="../assets/img/email.png" alt srcset />
              邮箱：{{store.email}}
            </span>
          </p>
        </div>
        <img :src="store_img[0][0].img" alt srcset />
      </div>
      <div class="tabs">
        <div class="tabs_filter">
          <span :class="{active:active==0}" @click="active = 0">門店圖片</span>
          <span :class="{active:active==1}" @click="active = 1">店面環境</span>
        </div>
        <swiper ref="swiper" :options="option" class="swiper pc" v-if="store_img.length">
          <swiper-slide v-for="(item,index) in store_img[active]" :key="index">
            <!-- <el-image :src="item.img" fit="fit"></el-image> -->
            <img :src="item.img" class="el-image" />
          </swiper-slide>
        </swiper>
        <swiper
          ref="swiper"
          :options="option1"
          class="swiper mobile"
          v-if="store_img[active].length"
        >
          <swiper-slide v-for="(item,index) in store_img[active]" :key="index">
            <img :src="item.img" class="el-image" />
          </swiper-slide>
        </swiper>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      store: {},
      store_img: [[], []],
      option: {
        slidesPerView: 3,
        spaceBetween: 53,
        loop: true,
        on: {
          transitionEnd: function() {}
        }
      },
      option1: {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        on: {
          transitionEnd: function() {}
        }
      }
    };
  },
  created() {
    this.axios.get("config/info").then(r => {
      this.store = { ...r };
    });
    this.axios.post("store/index", { type: 1 }).then(r => {
      // this.store_img[0].push([...r]);
      this.$set(this.store_img, 0, r || []);
    });
    this.axios.post("store/index", { type: 2 }).then(r => {
      this.$set(this.store_img, 1, r || []);
    });
  }
};
</script>

<style lang="less" scoped>
.store {
  background: rgb(251, 251, 251);
  padding: 0.37rem 0;
  main {
    padding: 0.25rem 3.6rem;
    & > img {
      width: 100%;
    }
    .option {
      display: flex;
      align-items: flex-end;
      margin-top: 0.8rem;
      margin-bottom: 1rem;
      justify-content: space-between;
      & > div {
        width: 6.5rem;
        margin-right: 1.03rem;
      }
      & > img {
        width: 4rem;
        height: 2.63rem;
      }
      .en {
        text-align: left;
        font-size: 0.18rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;

        span {
          font-size: 0.16rem;
          font-family: "Baskerville Old Face";
        }
      }
      label {
        width: 0.66rem;
        height: 0px;
        border: 2px solid rgba(0, 0, 0, 1);
        display: inline-block;
        margin-top: 0.36rem;
        margin-bottom: 0.24rem;
      }
      .desc {
        font-size: 0.14rem;
        font-family: "FZShuSong-Z01T";
        color: rgba(32, 32, 32, 1);
        display: flex;
        flex-direction: column;
        .titel {
          font-size: 0.16rem;
        }
        span {
          margin: 0.11rem 0;
          img {
            width: 0.2rem;
            height: 0.2rem;
            vertical-align: sub;
          }
        }
      }
    }
    .tabs {
      padding: 0 0.2rem;
      .tabs_filter {
        margin-bottom: 0.5rem;
        span {
          font-size: 0.16rem;
          color: rgba(0, 0, 0, 0.5);
          font-family: "FZShuSong-Z01T";
          margin-right: 0.8rem;
          cursor: pointer;
        }
        span.active {
          color: rgba(0, 0, 0, 1);
          border-bottom: 2px solid black;
          padding-bottom: 0.1rem;
        }
      }
      .el-image {
        height: 2.23rem;
        width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .store {
    padding: 30px 0;
    main {
      padding: 20px 10px;
      .option {
        display: block;
        & > div {
          width: 100%;
        }
        & > img {
          width: 100%;
          height: auto;
          margin-top: 20px;
        }
        .en {
          font-size: 16px;
          span {
            font-size: 12px;
          }
        }
        label {
          width: 100px;
        }
        .desc {
          font-size: 14px;
          .titel {
            font-size: 16px;
          }
          span {
            display: flex;
            align-items: center;
            line-height: 20px;
            img {
              width: 25px;
              height: auto;
              margin-right: 10px;
            }
          }
        }
      }
      .tabs {
        .tabs_filter {
          text-align: center;
          margin-bottom: 20px;
          span {
            font-size: 14px;
          }
        }
        .el-image {
          width: 100%;
          height: 100px;
        }
      }
    }
  }
  .head {
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/store.vue